module["exports"] = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "nearbpo.com",
  "corpfolder.com"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es_MX/internet/free_email.js
// module id = 927
// module chunks = 0